import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
export default function Footer() {
    const { t } = useTranslation();
    return (
        <footer className="flex flex-col gap-[10px] border-t-[1px] border-t-black">
            <div className="f-col p-[35px] container flex justify-between gap-[40px]">
                <div className="w-100 w-[35%] flex flex-col gap-[40px]">
                    <div className="flex flex-col gap-[8px]">
                        <Link to={"/"}>
                            <img className="w-[150px]" src={require("../../assets/logo/logo.svg").default} alt="" />
                        </Link>
                        <p className="text-[15px] text-black">
                            OMA – Where Precision Meets Elegance. Discover a brand that redefines eyewear through science, craftsmanship, and art.
                        </p>
                    </div>
                    <div className="flex flex-col gap-[8px]">
                        <div className="text-[#B88831] font-bold">{t("Follow Us:")}</div>
                        <div className="flex items-center gap-[8px]">
                            <Link to={"https://www.facebook.com/profile.php?id=61574762619083"}>
                                <img className="w-[28px] h-[28px]" src={require("../../assets/icons/facebook.svg").default} alt="" />
                            </Link>
                            <Link to={"https://www.instagram.com/be_academix/"}>
                                <img className="w-[28px] h-[28px]" src={require("../../assets/icons/instagram.svg").default} alt="" />
                            </Link>
                            <Link to={"https://wa.link/uz742h"}>
                                <img className="w-[28px] h-[28px]" src={require("../../assets/icons/whatsapp.svg").default} alt="" />
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="f-col w-100 w-[65%] flex gap-[40px] justify-end">
                    <div className="flex flex-col gap-[12px]">
                        <div className="text-[20px] font-bold text-[#B88831]">{t("Quick links")}</div>
                        <ul className="flex flex-col gap-[10px]">
                            <li>
                                <Link className="text-black text-[16px]" to={"/"}>{t("Home")}</Link>
                            </li>
                            <li>
                                <Link className="text-black text-[16px]" to={"/about"}>{t("About us")}</Link>
                            </li>
                            <li>
                                <Link className="text-black text-[16px]" to={"/brands"}>{t("Brands")}</Link>
                            </li>
                            <li>
                                <Link className="text-black text-[16px]" to={"/collections"}>{t("Collections")}</Link>
                            </li>
                            <li>
                                <Link className="text-black text-[16px]" to={"/contact"}>{t("Contact us")}</Link>
                            </li>
                        </ul>
                    </div>
                    <div className="flex flex-col gap-[12px]">
                        <div className="text-[20px] font-bold text-[#B88831]">{t("Get in touch")}</div>
                        <ul className="flex flex-col gap-[10px]">
                            <li>
                                <Link to={"tel:+962 7 912 3456"} className="flex items-center gap-[6px]">
                                    <img className="w-[20px] h-[20px]" src={require("../../assets/icons/phone-footer.svg").default} alt="" />
                                    <span className="dir-ar">+962 7 912 3456</span>
                                </Link>
                            </li>
                            <li>
                                <Link to={"mailto:info@omaeyewear.com"} className="flex items-center gap-[6px]">
                                    <img className="w-[20px] h-[20px]" src={require("../../assets/icons/email-footer.svg").default} alt="" />
                                    <span>info@omaeyewear.com</span>
                                </Link>
                            </li>
                            <li>
                                <Link to={""} className="flex items-center gap-[6px]">
                                    <img className="w-[20px] h-[20px]" src={require("../../assets/icons/location-footer.svg").default} alt="" />
                                    <span>{t("Amman - Jordan")}</span>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="bg-black py-[10px] text-white text-center font-bold">{t("© 2025 Oma Eye Wear All rights reserved.")}</div>
        </footer>
    );
}